import { forwardRef } from 'react';
import { Stack } from '@sixui/ui';
import { listItemTokens } from '@sixui/ui/components/ListItem/ListItem.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IFormSectionProps = IContainerProps & {
  children: React.ReactNode;
  sub?: boolean;
};

const styles = stylex.create({
  host$sub: {
    marginLeft: listItemTokens.leadingSpace,
  },
});

export const FormSection = forwardRef<HTMLDivElement, IFormSectionProps>(
  function FormSection(props, ref) {
    const { sx, children, sub } = props;

    return (
      <Stack gap={6} sx={[sub && styles.host$sub, sx]} ref={ref}>
        {children}
      </Stack>
    );
  },
);
